namespace Matrix.Data {
    export interface TestGroupRow {
        TestGroupCode?: string;
        Description?: string;
        LastRunBatchId?: number;
        PassCount?: number;
        FailCount?: number;
        WarnCount?: number;
        IgnoreCount?: number;
        ErrorCount?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TestList?: TestGroupTestRow[];
        LastRunBatchBatchDate?: string;
        LastRunBatchBatchCode?: string;
        LastRunBatchStartedBy?: string;
        LastRunBatchStartedWhen?: string;
        LastRunBatchFinishedWhen?: string;
        LastRunBatchDurationSeconds?: number;
        LastRunBatchSuccess?: boolean;
    }

    export namespace TestGroupRow {
        export const idProperty = 'TestGroupCode';
        export const nameProperty = 'TestGroupCode';
        export const localTextPrefix = 'Data.TestGroup';
        export const lookupKey = 'Data.TestGroup';

        export function getLookup(): Q.Lookup<TestGroupRow> {
            return Q.getLookup<TestGroupRow>('Data.TestGroup');
        }
        export const deletePermission = 'DataAdmin:TestGroup';
        export const insertPermission = 'DataAdmin:TestGroup';
        export const readPermission = 'Read:TestGroup';
        export const updatePermission = 'DataAdmin:TestGroup';

        export declare const enum Fields {
            TestGroupCode = "TestGroupCode",
            Description = "Description",
            LastRunBatchId = "LastRunBatchId",
            PassCount = "PassCount",
            FailCount = "FailCount",
            WarnCount = "WarnCount",
            IgnoreCount = "IgnoreCount",
            ErrorCount = "ErrorCount",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TestList = "TestList",
            LastRunBatchBatchDate = "LastRunBatchBatchDate",
            LastRunBatchBatchCode = "LastRunBatchBatchCode",
            LastRunBatchStartedBy = "LastRunBatchStartedBy",
            LastRunBatchStartedWhen = "LastRunBatchStartedWhen",
            LastRunBatchFinishedWhen = "LastRunBatchFinishedWhen",
            LastRunBatchDurationSeconds = "LastRunBatchDurationSeconds",
            LastRunBatchSuccess = "LastRunBatchSuccess"
        }
    }
}
